<template>
  <div class="bg-primary">
    <!-- Header -->
    <div class="header bg-gradient-blue py-7 py-lg-6 pt-lg-5">
      <b-container>
        <div class="header-body text-center mb-5">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">Select an account</h1>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-primary" points="2560 0 2560 100 0 100" />
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--7 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-body v-if="loading || errorMessage">
              <div class="text-center text-lg" v-if="loading">
                <i class="fa fa-spin fa-spinner mr-2"></i>Loading&hellip;
              </div>
            </b-card-body>
            <b-list-group v-if="!loading" flush>
              <b-list-group-item
                button
                @click="selectAccount(account)"
                v-for="account in accounts"
                :key="account.id"
              >
                <b-row>
                  <b-col cols="10">
                    {{ account.name | decode }}
                  </b-col>
                  <b-col cols="2" class="align-self-center text-center">
                    <i class="fa fa-arrow-right"></i>
                  </b-col>
                </b-row>
              </b-list-group-item>
              <b-list-group-item
                v-if="accounts && accounts.length < 1"
                class="text-center"
              >
                You're not in any accounts yet.
                <router-link to="/create-account">Create one?</router-link>
              </b-list-group-item>
            </b-list-group>
            <b-card-footer>
              <b-row>
                <b-col cols="6" class="text-left">
                  <b-btn variant="link" @click="logout">Log out</b-btn>
                </b-col>
                <b-col cols="6" class="text-right">
                  <b-btn to="/create-account" variant="info"
                    >Create account</b-btn
                  >
                </b-col>
              </b-row>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { BaseAlert } from "@/components";
import { get } from "dot-prop";

export default {
  components: {
    BaseAlert,
  },
  data() {
    return {
      accounts: [],
      loading: false,
      errorMessage: null,
    };
  },
  created() {
    this.loadAccounts();
  },
  methods: {
    logout() {
      this.$auth
        .logout()
        .then(() => {
          // clear any local storage
          this.$ls.clear();
          // clear from store
          this.$store.commit("SET_ACCOUNT", null);
          this.$store.commit("SET_MEMBERSHIP", null);
        })
        .catch((err) => {
          console.error("Error after logout(): ", err);
        });
    },
    loadAccounts: function () {
      this.loading = true;
      this.axios
        .get("/v1/accounts?sort=name")
        .then((response) => {
          this.loading = false;
          this.accounts = response.data;
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage = "Failed to load accounts list";
          if (get(error, "response.data.message")) {
            this.errorMessage = error.response.data.message;
          }
        });
    },
    selectAccount: function (account) {
      this.loading = true;
      // set to local storage
      this.$store.commit("SET_ACCOUNT", account);

      // load account user
      this.axios
        .get(`/v1/accounts/${account.id}/members/current`)
        .then((response) => {
          this.loading = false;
          this.$store.commit("SET_MEMBERSHIP", response.data);

          // go to account dashboard
          this.$router.push("/dashboard");
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage = "Failed to select account";
          if (get(error, "response.data.message")) {
            this.errorMessage = error.response.data.message;
          }
        });
    },
  },
};
</script>
